var $6ac9b6b1b7e3ca12$exports = {};
$6ac9b6b1b7e3ca12$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kleurkiezer`,
    "colorSwatch": `kleurstaal`,
    "transparent": `transparant`,
    "twoDimensionalSlider": `2D-schuifregelaar`
};


export {$6ac9b6b1b7e3ca12$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
